export default {
  all_layouts: "All Layouts",
  promoted_layouts: "Promoted Layouts",
  remaining_layouts: "Remaining Layouts",
  title: "Layouts",
}
